import { render, staticRenderFns } from "./i-msg-form.vue?vue&type=template&id=48968c3e&scoped=true"
import script from "./i-msg-form.vue?vue&type=script&lang=js"
export * from "./i-msg-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48968c3e",
  null
  
)

export default component.exports